// extracted by mini-css-extract-plugin
export default {"about":"About_about__U6j+1","skills":"About_skills__JXhcs","skill-tag":"About_skill-tag__QRnk+","content":"About_content__akggm"};